export const DEFAULT_IFRAME_EMBED = `<iframe data-testid="embed-iframe" style="border-radius:12px" src="" width="100%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>`;

export const IFRAME_ELEMENT_DEFAULT_WIDTH = 480;
export const IFRAME_ELEMENT_DEFAULT_HEIGHT = 152;
